@let state = $state();
<cm-asset-grid-cell>
    <cm-asset-cell-chip cm-top-left interactive [cdkMenuTriggerFor]="menuOptions">
        PBR Maps
        <i class="far fa-chevron-down"></i>
    </cm-asset-cell-chip>

    <div cm-top-right class="cm-actions-slot">
        @switch (state.kind) {
            @case ("empty") {
                @if ($canEdit() && $hasCyclesMaterial()) {
                    <cm-asset-cell-chip interactive (click)="onRenderSelected()"><i class="far fa-play"></i> Generate</cm-asset-cell-chip>
                }
            }
            @case ("loading") {
                @if ($canEdit()) {
                    <cm-asset-cell-chip interactive (click)="onCancelSelected()"><cm-loading-spinner-icon></cm-loading-spinner-icon> Cancel</cm-asset-cell-chip>
                }
            }
            @case ("failed") {
                @if ($canEdit()) {
                    <cm-asset-cell-chip interactive (click)="onRetrySelected()"><i class="far fa-rotate-reverse"></i> Retry</cm-asset-cell-chip>
                    <cm-asset-cell-chip interactive (click)="onRemoveSelected()"><i class="far fa-trash-can"></i></cm-asset-cell-chip>
                }
            }
            @case ("complete") {
                @if ($canDownload()) {
                    <a [href]="state.result.downloadUrl" [download]="state.result.originalFileName">
                        <cm-asset-cell-chip interactive><i class="far fa-arrow-to-bottom"></i></cm-asset-cell-chip>
                    </a>
                }
                @if ($canEdit()) {
                    <cm-asset-cell-chip interactive [cdkMenuTriggerFor]="actionsMenu.menu()">
                        <i class="far fa-ellipsis-v"></i>
                    </cm-asset-cell-chip>
                    <cm-asset-actions-menu #actionsMenu [actions]="actions" (action)="onAction($event)" />
                }
            }
        }
    </div>

    <div class="cm-icon-container">
        <img class="cm-icon" [src]="state.kind === 'complete' ? '/assets/images/pbr-maps-available.png' : '/assets/images/pbr-maps-unavailable.png'" alt="" />
        <div class="cm-caption">
            <span>Resolution: {{ $selectedResolution() }}</span>
            <span>Format: {{ $selectedFiletype() }}</span>
        </div>
    </div>

    @if (state.kind === "empty" && !$hasCyclesMaterial()) {
        <div class="cm-empty-overlay">
            <span class="cm-empty-message">Please create a material to generate outputs.</span>
        </div>
    }
</cm-asset-grid-cell>

<ng-template #menuOptions>
    <div cdkMenu class="cm-size-menu">
        @for (option of $options(); track option.type) {
            <span
                cdkMenuItem
                class="cm-size-label"
                [class.cm-size-selected]="option.isSelected"
                [class.cm-size-not-generated]="!option.isRendered"
                (cdkMenuItemTriggered)="onOptionMenuClick(option)"
            >
                {{ option.label }}
            </span>
            @if (option.isLoading) {
                @if ($canEdit()) {
                    <span cdkMenuItem class="cm-size-action" (cdkMenuItemTriggered)="onOptionCancelClick(option)">
                        <cm-loading-spinner-icon class="cm-size-icon"></cm-loading-spinner-icon> Cancel
                    </span>
                } @else {
                    <span></span>
                }
            } @else if (!option.isRendered) {
                @if ($canEdit() && $hasCyclesMaterial()) {
                    <span cdkMenuItem class="cm-size-action" (cdkMenuItemTriggered)="onOptionRenderClick(option)">
                        <i class="cm-size-icon far fa-play"></i> Generate
                    </span>
                } @else {
                    <span></span>
                }
            } @else if (option.result && $canDownload()) {
                <a cdkMenuItem class="cm-size-action" [href]="option.result.downloadUrl" [download]="option.result.originalFileName">
                    <i class="cm-size-icon far fa-arrow-to-bottom"></i> Download
                </a>
            } @else {
                <span></span>
            }
        }
    </div>
</ng-template>
